module.exports = __webpack_public_path__ + "img/horse.005e6bdd.gif";